<template src="./index.html"></template>
<script>
let id = 0;
import { comMapping } from '@/components/util/Function/comMapping';
import { getdata } from './data.js';
import { detailsingleQuery, tudztxxsave, tudztxxupdate, tudztxxdelete, queryByCompanyFcTdShenb, startTaxGather } from '../../../../../../../api/cztds.js';
export default {
	name: '',
	components: {},
	props: {
		invoicediag: {
			type: Boolean,
			default: false
		},
		mxsearch: {
			type: Object,
			default: {}
		},
		paramsx: {
			type: Object,
			default: {}
		},
		shoudata: {
			type: Number,
			default: 2
		},
		outlistx: {
			type: Object,
			default: {}
		}
	},
	watch: {
		shoudata: function(indexVal, oldVal) {
			if (indexVal > 1) {
				this.Period();
				this.invoicediag = false;
				this.page();
				this.title = '新增登记';
			} else if (indexVal < 1) {
				this.$nextTick(()=>{
					this.Period();
				})
				this.copyinvoice = false;
				this.title = '修改登记';
			}
		}
	},
	data: function() {
		return {
			maplist:[
					{
						value:null,
						item:'未采集'
					},
					{
						value:1,
						item:'未采集'
					},
					{
						value:2,
						item:'采集成功'
					},
					{
						value:3,
						item:'采集失败'
					},
					{
						value:4,
						item:'采集中'
					}
				],
			select_error: false,
			cztd: comMapping.$cztdlist,
			options: [],
			title: '新增登记',
			headData: getdata().headData,
			pagination: getdata().pagination,
			tableData: [{}],
			radio: {},
			value2: '',
			lebal: '',
			dropDown: [],
			copyinvoice: false,
			formlist: getdata().formlist,
			formdata: getdata().formdata,
			copyinvoices: false,
			cyit: [],
			index: [],
			qxlx:'',
			drop:'',
		};
	},
	mounted() {
		this.uetiu();
	},
	methods: {
		Shui(e){
			this.$showConfirm({
			 		  message: "是否上传税源至税局?",
					  title:"标题",
			 		}).then((res) => {
			 		  if (res == "confirm") {
					let params = {
						type:'4',
						detailIds:e.id
					}
					startTaxGather(params).then(res=>{
						if(res.data.code == 1 ){
							this.page();
						}else{
							this.$message.error(res.data.msg)
						}
					})
			 		  }
			 		});
		},
		onchange(e){
			// if (this.paramsx.sectionSpan=="") {
				this.drop.map(item=>{
					if(item.suossqz==this.paramsx.suosqqz){
						this.qxlx = item.qxlx
					}
				})
			// }else{
			// 	this.qxlx =this.paramsx.sectionSpan
			// }
			// console.log(this.qxlx)
			this.shuiebz()
		},
		Period() {
			this.dropDown = [];
			
			let params = {
				companyNo: this.outlistx.companyNo,
				suosq: this.outlistx.suosq,
				type: 'cztds'
			};
			queryByCompanyFcTdShenb(params).then(res => {
				if (res.data.code == 1) {
					this.drop = res.data.data
					res.data.data.map(item => {
						this.dropDown.push({
							value: item.suossqz,
							label: item.suossqz
						});
					});
					this.onchange()
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		uetiu() {
			let UrbanData = window.$UrbanData_mb || window.$UrbanData;
			keyt(UrbanData);
			function keyt(data) {
				data.map(item => {
					item.value = item.label;
					if (item.children) {
						keyt(item.children);
					}
				});
			}
			let data = JSON.parse(JSON.stringify(UrbanData));
			this.options = data.map(item => {
				item.children.map(item1 => {
					item1.children.map(item2 => {
						delete item2.children;
					});
				});
				return item;
			});
		},
		shuiebz(e) {
			if (this.paramsx.benqyjse == '' || this.paramsx.benqyjse == null) {
				this.paramsx.benqyjse = '0';
			}else{
				this.paramsx.benqyjse = this.paramsx.benqyjse+'';
			}
			if (this.paramsx.zhanytdmj == '' || this.paramsx.zhanytdmj == null) {
				this.paramsx.zhanytdmj = 0;
			}
			if (this.paramsx.liuslfjmse == '' || this.paramsx.liuslfjmse == null) {
				this.paramsx.liuslfjmse = 0;
			}
			// this.paramsx.yingnse = this.paramsx.shuiebz * this.paramsx.zhanytdmj;
			this.paramsx.yingnse = (this.paramsx.shuiebz * this.paramsx.zhanytdmj) / 12;
			 if (this.qxlx == '2') {
				this.paramsx.yingnse = this.paramsx.yingnse * 3;
			} else if (this.qxlx == '3') {
				this.paramsx.yingnse = this.paramsx.yingnse * 6;
			}else if(this.qxlx == '4'){
				this.paramsx.yingnse = this.paramsx.yingnse * 12;
			}else{
				this.paramsx.yingnse = this.paramsx.yingnse;
			}
			let amount = 0;
			this.paramsx.jianms.forEach((item, index) => {
				if (item.jianmje != '' && item.jianmqsyf != '' && item.jianmqsyf != null && item.jianmzzyf != '' && item.jianmzzyf != null) {
					let times = 1;
					let start = item.jianmqsyf.substring(4, 6);
					let stop = item.jianmzzyf.substring(4, 6);
					if (start <= stop) {
						times = stop - start == 0 ? 1 : stop - start + 1;
					} else {
						let centre = item.jianmqsyf;
						item.jianmqsyf = item.jianmzzyf;
						item.jianmzzyf = centre;
						start = item.jianmqsyf.substring(4, 6);
						stop = item.jianmzzyf.substring(4, 6);
						times = stop - start + 1;
					}
					amount += Number(item.jianmje) * times;
				}
			});
			if (this.outlistx.lflszc == 'Y') {
				this.paramsx.liuslfjmse = (this.paramsx.yingnse - amount) / 2;
			}
			this.paramsx.benqybtse = this.paramsx.yingnse - this.paramsx.liuslfjmse - this.paramsx.benqyjse - amount;
		},
		remove() {
			if (this.value2 == 1) {
				this.$showConfirm({
					message: '确认删除?'
				}).then(res => {
					if (res == 'confirm') {
						let params = { id: this.formdata.id };
						tudztxxdelete(params).then(res => {
							if (res.data.code == 1) {
								this.copyinvoices = false;
								this.page();
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				});
			} else {
				this.copyinvoices = false;
			}
		},
		xq(e) {
			this.formdata = JSON.parse(JSON.stringify(e));
			console.log(this.formdata)
			console.log(e)
			this.formdata.tudzldzShi = [e.tudzldzSheng, e.tudzldzShi, e.tudzldzXian];
			this.info();
			this.copyinvoices = true;
			this.value2 = 1;
		},
		nextztxx() {
			if (this.formdata.tudzldzShi == '') {
				this.select_error = true;
				this.$refs.taxform.submitForm();
			} else {
				this.$refs.taxform.submitForm();
			}
		},
		alone() {
			if (this.formdata.tudzldzShi == '') {
				this.select_error = true;
			}
		},
	
		xzzt() {
			this.value2 = 2;
			this.select_error = false;
			this.formlist[14].selectval = [];
			this.formdata = getdata().formdata
			Object.keys(this.formdata).map(key => {
				if(key == 'nsywYxqz'){
				this.formdata[key] = '2099-12-31';
				}else{
					this.formdata[key] = '';
				}
			});
			this.formdata = JSON.parse(JSON.stringify(this.formdata))
			this.info();
			this.copyinvoices = true;
			this.$refs.taxform.clearValidate();
		},
		// 初始化数据
		info() {
			this.formlist.map(item => {
				if (item.prop == 'nsrlx') {
					item.selectval = [];
					this.mxsearch.cztdNsrxz.map(item1 => {
						item.selectval.push(item1);
					});
				} else if (item.prop == 'tudxz') {
					item.selectval = [];
					this.mxsearch.cztdTdxz.map(item1 => {
						item.selectval.push(item1);
					});
				} else if (item.prop == 'tudyt') {
					item.selectval = [];
					this.mxsearch.cztdTdyt.map(item1 => {
						item.selectval.push(item1);
					});
				} else if (item.prop == 'tudqdfs') {
					item.selectval = [];
					this.mxsearch.cztdTdqdfs.map(item1 => {
						item.selectval.push(item1);
					});
				} else if (item.prop == 'tuddj') {
					item.selectval = [];
					this.mxsearch.cztdTddj.map(item1 => {
						item.selectval.push(item1);
					});
				}
			});
		},
		nextxx() {
			Object.keys(this.radio).map(key => {
				this.paramsx[key] = this.radio[key];
			});
			console.log(this.qxlx)
			if (this.qxlx!=''&&this.qxlx!=null&&this.qxlx!=undefined) {
			this.shuiebz();
			}
			this.copyinvoice = false;
			this.radio = {};
		},
		page() {
			let params = {
				nsrsbh: this.outlistx.nsrsbh,
				size: this.pagination.pageSize,
				current: this.pagination.pageNum
			};
			detailsingleQuery(params).then(res => {
				if (res.data.code == 1) {
					res.data.data.records.map(item => {
						if (item.nsrlx) {
							this.mxsearch.cztdNsrxz.map(item1 => {
								if (item.nsrlx == item1.value) {
									item.nsrlxx = item1.label;
								}
							});
							this.mxsearch.cztdTdbglxXxxbg.map(item2 => {
								if (item.nsrlx == item2.value) {
									item.nsrlxx = item2.label;
								}
							});
						}
						if (item.tudxz) {
							this.mxsearch.cztdTdxz.map(item1 => {
								if (item.tudxz == item1.value) {
									item.tudxzx = item1.label;
								}
							});
						}
						if (item.tudyt) {
							this.mxsearch.cztdTdyt.map(item1 => {
								if (item.tudyt == item1.value) {
									item.tudytx = item1.label;
								}
							});
						}
						if (item.tudqdfs) {
							this.mxsearch.cztdTdqdfs.map(item1 => {
								if (item.tudqdfs == item1.value) {
									item.tudqdfsx = item1.label;
								}
							});
						}
					});
					this.tableData = res.data.data.records;
					this.pagination.total = res.data.data.total;
					this.invoicediag = true;
					setTimeout(v => {
						this.copyinvoice = true;
					}, 0);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		oucz() {
			this.page();
			this.copyinvoice = true;
		},
		nextxz() {
			if (this.paramsx.tudbh == '' || this.paramsx.tuddj == '' || this.paramsx.shuiebz == ''||this.paramsx.suosqqz == '') {
				if (this.paramsx.tudbh == '') {
					return this.$message.error('请选择您需要的土地总体信息');
				} else {
					return this.$message.error('请补充完整必填部分');
				}
			}
			if (this.paramsx.shuiebz == '' || this.paramsx.shuiebz == null) {
				this.paramsx.shuiebz = 0;
			}
			this.$emit('nextxz', this.paramsx);
		},
		suosqchange() {},
		outset(e) {
			this.formdata.tudzldzXiangz = '';
			// this.formlist[14].selectval =  this.$ctx({level:4,name:e[2]})
			this.select_error = false;
			let index = 0;
			let UrbanData = window.$UrbanData_mb || window.$UrbanData;
			this.Urban(UrbanData, e, index);
			this.formlist[16].selectval = this.index;
		},
		Urban(list, e, index) {
			list.map(item => {
				if (item.value == e[index]) {
					if (index < 2) {
						index++;
						this.Urban(item.children, e, index);
					} else {
						this.index = item.children;
					}
				}
			});
		},
		getdatasave() {
			let outx = { ...this.formdata };
			outx.nsrsbh = this.outlistx.nsrsbh;
			outx.tudzldzSheng = outx.tudzldzShi[0];
			outx.tudzldzXian = outx.tudzldzShi[2];
			outx.tudzldzShi = outx.tudzldzShi[1];
			let params = outx;
			if (this.value2 == 2) {
				tudztxxsave(params).then(res => {
					if (res.data.code == 1) {
						this.copyinvoices = false;
						this.page();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			} else {
				tudztxxupdate(params).then(res => {
					if (res.data.code == 1) {
						this.copyinvoices = false;
						this.page();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			}
		},
		outchange() {},
		closediag() {
			this.$emit('closediag', false);
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.page();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.page();
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
